module.exports = __webpack_public_path__ + "static/images/callout_2.34bc829f5e6ec6998a5a557f5c63efcc.jpg";